import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-caption" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-4 pt-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "text-center ma-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "1",
                class: "pa-1"
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (day) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: day.label,
                  class: "text-caption text-grey-darken-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(day.label), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.format(day.date, 'dd/MM')), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "1" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeSlots, (slot) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: slot,
                      class: "time-slot-label"
                    }, _toDisplayString(slot), 1))
                  }), 128))
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (day) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: day.label,
                  class: "border-left",
                  style: {"border-left":"1px solid #ccc"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeSlots, (slot) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: slot,
                        class: "time-slot-cell",
                        onClick: ($event: any) => (_ctx.handleCreate(day.date, slot))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEventsForDateTime(day.date, slot), (event) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: event.id,
                            class: "event-chip"
                          }, [
                            _createVNode(_component_v_chip, {
                              color: "white",
                              size: "x-small",
                              class: "ma-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(event.name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128))
                      ], 8, _hoisted_2))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}